import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ownerState"],
  _excluded2 = ["ownerState"],
  _excluded3 = ["ownerState"];
import * as React from 'react';
import { Progress } from '@base-ui/react/progress';

// ---------------------------------------------------------------------------
// Thin wrappers that strip `ownerState` before forwarding to Base UI Progress.
// `useSlotProps` adds `ownerState` for non-string element types, but Base UI
// components would pass it through to the DOM as an unknown attribute.
//
// This mirrors the same pattern used in ScrollAreaSlots.tsx.
// ---------------------------------------------------------------------------
import { jsx as _jsx } from "react/jsx-runtime";
export const ProgressRoot = /*#__PURE__*/React.forwardRef(function ProgressRoot(props, ref) {
  const other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Progress.Root, _extends({}, other, {
    ref: ref
  }));
});
if (process.env.NODE_ENV !== "production") ProgressRoot.displayName = "ProgressRoot";
export const ProgressTrack = /*#__PURE__*/React.forwardRef(function ProgressTrack(props, ref) {
  const other = _objectWithoutPropertiesLoose(props, _excluded2);
  return /*#__PURE__*/_jsx(Progress.Track, _extends({}, other, {
    ref: ref
  }));
});
if (process.env.NODE_ENV !== "production") ProgressTrack.displayName = "ProgressTrack";
export const ProgressIndicator = /*#__PURE__*/React.forwardRef(function ProgressIndicator(props, ref) {
  const other = _objectWithoutPropertiesLoose(props, _excluded3);
  return /*#__PURE__*/_jsx(Progress.Indicator, _extends({}, other, {
    ref: ref
  }));
});
if (process.env.NODE_ENV !== "production") ProgressIndicator.displayName = "ProgressIndicator";